// choice-tiles.js — transforme des <select> en tuiles (UI uniquement), sans toucher à la logique.
// Cible: [is-unit-cut] et [is-amalgame-ability]

(function () {
  const BRAND = '#d5377b';

  // ==== Utilitaires ====
  const nextFrame = () => new Promise(r => requestAnimationFrame(r));
  async function waitForEl(selector, timeoutMs = 8000){
    const t0 = performance.now();
    let el = document.querySelector(selector);
    while(!el && performance.now() - t0 < timeoutMs){
      await nextFrame(); el = document.querySelector(selector);
    }
    return el || null;
  }
  function hideSelectVisually(select){
    const wrap = select.closest('.select--wrap') || select.parentElement;
    if (!wrap) return;
    wrap.style.position = 'absolute';
    wrap.style.inset = '0';
    wrap.style.pointerEvents = 'none';
    select.style.opacity = '0';
    select.style.width = '1px';
    select.style.height = '1px';
  }

  // Images optionnelles (remplace par tes URLs si tu veux des pictos dédiés)
  const ICONS = {
    unitCut: {
      'LE_MOINS_CHER': 'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/xml_version__1.0__encoding__UTF-8_____svg_id__Calque_1__data-name__Calque_1__xmlns__http___www.w3.org_2000_svg__xmlns_xlink__http___www.w3.org_1999_xlink__viewBox__0_0_5979.41_7416.48_cad28f99-72b7-4db0-a122-7c3d9fc246de.png?v=1760601017',
      'OUI':            'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/xml_version__1.0__encoding__UTF-8_____svg_id__Calque_1__data-name__Calque_1__xmlns__http___www.w3.org_2000_svg__xmlns_xlink__http___www.w3.org_1999_xlink__viewBox__0_0_5979.41_7416.48_e3d6df34-3e63-48d1-ae96-2d4e4c3a3769.png?v=1760601017',
      'NON':            'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/xml_version__1.0__encoding__UTF-8_____svg_id__Calque_1__data-name__Calque_1__xmlns__http___www.w3.org_2000_svg__xmlns_xlink__http___www.w3.org_1999_xlink__viewBox__0_0_5979.41_7416.48_ce698f67-a404-4591-a178-d678bc48f7fb.png?v=1760601017'
    },
    amalgame: {
      'OUI':           'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/xml_version__1.0__encoding__UTF-8_____svg_id__Calque_1__data-name__Calque_1__xmlns__http___www.w3.org_2000_svg__xmlns_xlink__http___www.w3.org_1999_xlink__viewBox__0_0_5979.41_7416.48.png?v=1760601017',
      'NON':           'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/xml_version__1.0__encoding__UTF-8_____svg_id__Calque_1__data-name__Calque_1__xmlns__http___www.w3.org_2000_svg__xmlns_xlink__http___www.w3.org_1999_xlink__viewBox__0_0_5979.41_7416.48_7d6ca17f-b1fb-4026-9661-e6b20ea428cb.png?v=1760601017',
      'JE NE SAIS PAS':'https://cdn.shopify.com/s/files/1/0606/3797/0611/files/xml_version__1.0__encoding__UTF-8_____svg_id__Calque_1__data-name__Calque_1__xmlns__http___www.w3.org_2000_svg__xmlns_xlink__http___www.w3.org_1999_xlink__viewBox__0_0_5979.41_7416.48_b6cf214c-e8e4-4a77-8368-aba6d897df30.png?v=1760601017'
    }
  };

  // Fabrique des tuiles pour un <select>
  function makeTiles(select, { key, order = [], iconMap = {} }){
    // Évite double init
    if (select.dataset.tilesReady === '1') return;

    const box = select.closest('.input--box') || select.parentElement;
    if (!box) return;

    // Conteneur
    const wrap = document.createElement('div');
    wrap.className = 'option-tiles';
    wrap.setAttribute('role', 'radiogroup');
    box.appendChild(wrap);

    // Ordonne les options si "order" fourni
    const opts = Array.from(select.options).filter(o => (o.value || '').trim() !== '');
    const options = order.length
      ? opts.sort((a,b) => (order.indexOf(a.value) === -1 ? 999 : order.indexOf(a.value)) - (order.indexOf(b.value) === -1 ? 999 : order.indexOf(b.value)))
      : opts;

    // Crée chaque tuile
    const tiles = options.map(opt => {
      const tile = document.createElement('button');
      tile.type = 'button';
      tile.className = 'option-tile';
      tile.setAttribute('role', 'radio');
      tile.setAttribute('aria-checked', opt.selected ? 'true' : 'false');
      tile.dataset.value = opt.value;

      const imgBox = document.createElement('div');
      imgBox.className = 'option-tile__img';

      const src = iconMap[opt.value] || iconMap[(opt.text||'').toUpperCase()] || null;
      if (src) {
        const img = document.createElement('img');
        img.loading = 'lazy';
        img.decoding = 'async';
        img.alt = opt.text;
        img.src = src;
        imgBox.appendChild(img);
      } else {
        // petit placeholder SVG inline
        imgBox.innerHTML = `
          <svg viewBox="0 0 120 120" width="44" height="44" aria-hidden="true">
            <rect x="10" y="10" width="100" height="100" rx="10" fill="#f0f0f2" stroke="#ddd"/>
            <path d="M15 85 C45 65, 75 105, 105 85" fill="none" stroke="${BRAND}" stroke-width="4"/>
            <path d="M70 30 l15 10 -15 10" fill="none" stroke="${BRAND}" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>`;
      }

      const label = document.createElement('div');
      label.className = 'option-tile__label';
      label.textContent = opt.text;

      tile.appendChild(imgBox);
      tile.appendChild(label);

      tile.addEventListener('click', () => {
        select.value = opt.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        tiles.forEach(t => t.setAttribute('aria-checked','false'));
        tile.setAttribute('aria-checked','true');
      });

      wrap.appendChild(tile);
      return tile;
    });

    // Sync quand le JS métier change la valeur
    select.addEventListener('change', () => {
      const v = select.value;
      tiles.forEach(t => t.setAttribute('aria-checked', t.dataset.value === v ? 'true' : 'false'));
    });

    // Masque visuellement le select ciblé uniquement
    hideSelectVisually(select);
    select.dataset.tilesReady = '1';
  }

  // ==== Init ====
  async function init(){
    // 1) Découpe des logos unitaires (LE_MOINS_CHER / OUI / NON)
    const unitCut = await waitForEl('[is-unit-cut]');
    if (unitCut) {
      makeTiles(unitCut, {
        key: 'unitCut',
        order: ['LE_MOINS_CHER', 'OUI', 'NON'],
        iconMap: ICONS.unitCut
      });
    }

    // 2) Capacité d’amalgame (OUI / NON / JE NE SAIS PAS)
    const amalgame = await waitForEl('[is-amalgame-ability], #amalgameAbility');
    if (amalgame) {
      makeTiles(amalgame, {
        key: 'amalgame',
        order: ['OUI','NON','JE NE SAIS PAS'],
        iconMap: ICONS.amalgame
      });
    }
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
